import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MessageBoxComponent } from '../components/message-box/message-box.component';
const VALIDATION_MESSAGE: string = 'Click <b>Ok</b> to go to the first missing field.';
@Injectable({
  providedIn: 'root'
})
export class MessageBoxService {

  constructor(public dialog: MatDialog) { }

  showMessage(options: {
    title?: string,
    message?: string,
    confirm?: boolean,
    warning?: boolean,
    error?: boolean,
    sucess?: boolean,
    alignTitle?: string,
    alignMessage?: string
  }): Observable<any> {
    return this.dialog.open(MessageBoxComponent, {
      disableClose: true,
      data: options
    }).afterClosed();
  }

  success(options: {
    title?: string,
    message?: string
  }): Observable<any> {

    return this.dialog.open(MessageBoxComponent, {
      disableClose: true,
      data: {
        title: options.title,
        message: options.message,
        alignMessage: 'center',
        alignTitle: 'center',
        sucess: true
      }
    }).afterClosed();

  }

  error(options: {
    title?: string,
    message?: string
  }): Observable<any> {

    return this.dialog.open(MessageBoxComponent, {
      disableClose: true,
      data: {
        title: options.title,
        message: options.message,
        alignMessage: 'center',
        alignTitle: 'center',
        error: true
      }
    }).afterClosed();

  }

  warn(options: {
    title?: string,
    message?: string
  }): Observable<any> {

    return this.dialog.open(MessageBoxComponent, {
      disableClose: true,
      data: {
        title: options.title,
        message: options.message,
        alignMessage: 'center',
        alignTitle: 'center',
        warn: true
      }
    }).afterClosed();

  }

  validationError(options: { title?: string; message?: string, element?: string }, callback?: () => void): Observable<any> {
    const dialogRef = this.dialog.open(MessageBoxComponent, {
      disableClose: true,
      data: {
        title: options.title,
        message: options.message || VALIDATION_MESSAGE,
        alignMessage: 'center',
        alignTitle: 'center',
        error: true
      }
    });

    // Call the callback function after dialog closes
    dialogRef.afterClosed().subscribe(() => {
      if (callback) {
        callback(); // Execute the callback 
      } else if (options.element) {
        this.scrollToElement(options.element);
      } else {
        this.scrollToRequiredLabel();
      }
    });

    return dialogRef.afterClosed();
  }

  scrollToRequiredLabel(): void {
    // Find the first label that contains 'Required'
    const requiredLabel = Array.from(document.querySelectorAll('label, mat-error'))
      .find((label: HTMLElement) => label.textContent?.includes('Required') ||
        (label.classList.contains('mat-error') && label.classList.contains('ng-star-inserted'))
      );
    //mat-error ng-star-inserted
    if (requiredLabel) {
      // Scroll the required element into view
      requiredLabel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.warn('No required label found.');
    }
  }

  scrollToElement(elementId?: string): void {
    const element = document.getElementById(elementId?? 'cummunity-level-transmission');

    if (element) {
      // Scroll the element into view
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.warn(`Element with id "${elementId}" not found.`);
    }
  }

  confirm(options: {
    title?: string,
    message?: string,
    warn?: boolean
  }): Observable<any> {

    return this.dialog.open(MessageBoxComponent, {
      disableClose: true,
      data: {
        title: options.title,
        message: options.message,
        alignMessage: 'center',
        alignTitle: 'center',
        confirm: true,
        warn: options.warn
      }
    }).afterClosed();

  }

}
